window.MiQ = window.MiQ || {};
import * as MiQ from "./src";
// Object.defineProperties(window.MiQ, MiQ);

MiQ.Logger.info(`[miq-scripts][${window.MiQ.Configs.version}] loaded`);

// try to track Web Page Viewed for affiliate landing pages
// those are pages with a pathname starting matching the following format:
// `/lp/<page-variant>`

let lpMatch = window.location.pathname.match(/\/lp\/([\w-]+)/);
if (lpMatch?.length > 1) {
  let lpVariant = lpMatch[1];
  window.MiQ.Telemetry.exec(() => {
    window.MiQ.Telemetry.trackWebPageViewed(
      "Affiliate Landing Page",
      lpVariant
    );
  });
}
